/* eslint-disable @typescript-eslint/no-explicit-any */
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip);

export default function WeeklySalesCard() {
  // Create gradient colors for the bars
  const gradientColors = [
    "hsl(151, 65%, 45%)", // Darker green
    "hsl(151, 65%, 47%)", // Slightly lighter
    "hsl(151, 65%, 50%)", // Medium green
    "hsl(151, 65%, 53%)", // Lighter
    "hsl(151, 65%, 55%)", // Even lighter
    "hsl(151, 65%, 58%)", // Light green
    "hsl(151, 65%, 60%)", // Lightest green
  ];

  const data = {
    labels: ["S", "M", "T", "W", "T", "F", "S"],
    datasets: [
      {
        data: [35, 50, 65, 40, 45, 70, 38],
        backgroundColor: gradientColors,
        borderRadius: 6,
        barThickness: 16,
      },
    ],
  };

  const options = {
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#cbd5e1", font: { size: 12 } },
      },
      y: {
        grid: { color: "#374151" },
        ticks: {
          color: "#cbd5e1",
          font: { size: 12 },
          stepSize: 20,
        },
        beginAtZero: true,
        max: 80,
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context: any) {
            return `Sales: ${context.raw}`;
          },
        },
      },
    },
  };

  return (
    <div className="bg-background border border-surface-2 text-white rounded-xl p-4 w-1/4 flex flex-col gap-12">
      <h2 className="text-sm font-semibold text-primary dark:text-primary mb-2">
        Weekly Sales
      </h2>

      {/* Image */}
      <img
        src="https://images.unsplash.com/photo-1507089947368-19c1da9775ae?fit=crop&w=500&q=80"
        alt="Property"
        className="w-full h-40 object-cover rounded-lg mb-4"
      />

      {/* Chart */}
      <div className="mb-6">
        <Bar data={data} options={options} />
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between border-t border-gray-700 pt-4">
        <div>
          <p className="text-sm text-primary dark:text-primary">
            Total Property Seals :
          </p>
          <p className="text-lg font-medium text-primary dark:text-primary">
            5,746
          </p>
        </div>
        <button className="bg-gradientButton hover:bg-primary/90 text-white dark:bg-primary/80 dark:hover:bg-primary/70 dark:text-black/90 transition-colors duration-200 font-medium shadow-sm hover:shadow-md text-sm px-4 py-2 rounded">
          View More
        </button>
      </div>
    </div>
  );
}
